import React from 'react';

const Terms = () => (
  <div className="max-w-4xl mx-auto px-6 py-20 prose dark:prose-invert">
    <h1 className="font-serif text-4xl mb-8">Terms of Service</h1>
    <p className="text-slate-500">Effective Date: May 20, 2024</p>
    <section className="mt-12 space-y-6">
      <h2 className="text-2xl font-bold">1. Usage Agreement</h2>
      <p>By using Weaver, provided by Big Hook Media Inc., you agree to use the platform for creative storytelling purposes only and to respect the collaborative nature of shared sessions.</p>
      <h2 className="text-2xl font-bold">2. Content Ownership</h2>
      <p>Users retain full ownership of the intellectual property they create within Weaver. Big Hook Media Inc. provides the tools but claims no rights to your narratives.</p>
      <h2 className="text-2xl font-bold">3. Liability</h2>
      <p>Weaver is provided "as is". While we strive for 100% uptime, Big Hook Media Inc. is not liable for data loss due to browser storage clearing or AI service interruptions.</p>
    </section>
  </div>
);

export default Terms;